import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { LiteSlateEditor } from "../../lite-slate-editor"
import { EditableImage } from "../../../header/editable/editable-image"
import { getRatio } from "../../components/column-ratio"
import { ConditionalLink } from "../../../shared/conditional-link"
import { GAP_IF_UNDEFINED } from "./constants"

const DEFAULT_IMAGE_URL =
  "https://cdn.convertkit.com/assets/article-layout-placeholder.jpeg"

const styles = `
  @media only screen and (max-width:600px) {
    .ck-articlelistitem td {
      display: block !important;
      width: 100% !important;
      padding: 0 !important;
    }

    .ck-articlelistitem img {
      margin-bottom: 18px !important;
    }
  }
`

export function ArticleListItem({ block_id, properties }) {
  const { children } = useBlocks(block_id)

  const containerStyle = {
    backgroundColor: properties.backgroundColor,
    paddingTop: properties.verticalPadding,
    paddingRight: properties.horizontalPadding,
    paddingBottom: properties.verticalPadding,
    paddingLeft: properties.horizontalPadding,
    borderTopLeftRadius: properties.borderTopLeftRadius,
    borderTopRightRadius: properties.borderTopRightRadius,
    borderBottomLeftRadius: properties.borderBottomLeftRadius,
    borderBottomRightRadius: properties.borderBottomRightRadius,
    borderTopWidth: properties.borderTopWidth,
    borderRightWidth: properties.borderRightWidth,
    borderBottomWidth: properties.borderBottomWidth,
    borderLeftWidth: properties.borderLeftWidth,
    borderColor: properties.borderColor,
    borderStyle: "solid",
    imageBorderRadius: properties.imageBorderRadius,
    overflow: "hidden"
  }

  const gap =
    (properties.gap === undefined ? GAP_IF_UNDEFINED : properties.gap) / 2

  const handleLayoutClick = e => {
    e.preventDefault()
    e.stopPropagation()
  }

  return (
    <div
      style={containerStyle}
      bgcolor={properties.backgroundColor}
      className="ck-articlelistitem  ck-layout-block-template"
    >
      <table
        border="0"
        cellPadding="0"
        cellSpacing="0"
        width="100%"
        bgcolor={properties.backgroundColor}
      >
        <tbody>
          <tr>
            <td
              width={getRatio(properties.columnRatio, "left")}
              style={{ verticalAlign: "top", paddingRight: gap }}
            >
              <ConditionalLink
                onClick={handleLayoutClick}
                href={properties.imageUrl}
              >
                <EditableImage
                  name="image"
                  src={properties.image || DEFAULT_IMAGE_URL}
                  alt={properties.alt}
                  width="100%"
                  height="auto"
                  style={{
                    maxWidth: "100%",
                    display: "block",
                    borderRadius: properties.imageBorderRadius
                  }}
                />
              </ConditionalLink>
            </td>
            <td
              width={getRatio(properties.columnRatio, "right")}
              style={{ verticalAlign: "middle", paddingLeft: gap }}
            >
              <LiteSlateEditor block_id={children[0].block_id} />
            </td>
          </tr>
        </tbody>
      </table>
      <style>{styles}</style>
    </div>
  )
}
